import { createContext, useEffect, useState, ReactNode } from "react";
import api, { callLogin, callLogout } from "../services/api";
import { reachGoal } from "../utils/yandexMetrica";
// import { useNavigate } from "react-router";

export interface User {
    email: string | null;
    name: string | null;
    surname: string | null;
    userId: number | null;
    avatar: string | null;
    code: string | null;
    banner?: any;
    quote?: string | null;
    about?: string | null;
    mode?: string | null;
    language?: string | null;
    dob?: string | null;
    phone?: string | null;
}

interface AuthContextType {
    currentUser: User | null;
    setCurrentUser: (user: User | null) => void;
    login: (inputs: any) => Promise<void>;
    // checkEmail: (inputs: any) => Promise<void>;
    logout: () => Promise<void>;
    refreshToken: () => Promise<void>;
    authReady: boolean;
    setAuthReady: React.Dispatch<React.SetStateAction<boolean>>;
}

export const AuthContext = createContext<AuthContextType>({
    //DEFAULT VALUES
    currentUser: null,
    setCurrentUser: () => {},
    login: async () => {},
    // checkEmail: async () => {},
    logout: async () => {},
    refreshToken: async () => {},
    authReady: false,
    setAuthReady: () => { },
});

interface AuthContextProviderProps {
    children: ReactNode;
}



export const AuthContextProvider = ({ children }: AuthContextProviderProps) => {
    const [authReady, setAuthReady] = useState(false);
    const [currentUser, setCurrentUser] = useState<User | null>(() => {
        try {
            const storedUser = localStorage.getItem("user");
            return storedUser ? JSON.parse(storedUser) : null;
        } catch {
            localStorage.removeItem("user");
            return null;
        }
    });

    useEffect(() => {
        if (currentUser !== null) {
            reachGoal('RETURNING_USER');
        }
        setAuthReady(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const login = async (inputs: any) => {
        try {
            const res = await callLogin(inputs);
            const user = res;
            setCurrentUser(user);
            reachGoal('LOGIN');
        } catch (error) {
            throw error;
        }
    };


    const logout = async () => {
        try {
            await callLogout();
            setCurrentUser(null);
            localStorage.removeItem("user");
            const matchingTest = Object.keys(localStorage).filter(key =>
                key.startsWith("testProgress")
            );
            if (matchingTest) {
                matchingTest.map(key => localStorage.removeItem(key))
            }
        } catch (error) {
            throw error;
        }
    };

    // const navigate = useNavigate()

   
    const refreshToken = async () => {
        try {
            await api.post("/auth/refreshToken", {}, { withCredentials: true });
        } catch (error) {
            console.error("Refresh token error:", error);
            
            throw error;
        } finally {
            setAuthReady(true)
        }
    };


    // UPDATE LOCAL STORAGE WHEN CURRENT USER CHANGES
    useEffect(() => {
    if (currentUser !== null && currentUser !== undefined) {
        localStorage.setItem("user", JSON.stringify(currentUser));
    }
}, [currentUser]);

    
    const contextValue: AuthContextType = {
        currentUser,
        setCurrentUser,
        login,
        // checkEmail,
        logout,
        refreshToken,
        authReady,
        setAuthReady
    };

    return (
        <AuthContext.Provider value={contextValue}>
            {children}
        </AuthContext.Provider>
    );
};
